import { PickListItem, JsonItem, PickListItemSorted, RevamppCenter, RevamppCore, RevamppProject } from "../list-management.objects";
import { DropdownGroup } from "../list-management.filters";
import { SpecialCaseEntity } from "../list-management.form-sections";
import _, { drop, property } from "lodash";
export class CenterCoreProjectSelection implements SpecialCaseEntity {
    id: string;
    displayName: string;
    description: string;

    centerPropName: string;
    centerPickListName: string;
    centerList: RevamppCenter[];

    corePropName: string;
    corePickListName: string;
    coreList: RevamppCore[];

    projectPropName: string;
    projectPickListName: string;
    projectList: RevamppProject[];

    storedCenterId: number;
    storedCoreId: number;
    storedProjectId: number;

    isNew: boolean;

    constructor(id: string, propertyNames: string[], pickListNames: string[], displayName: string, description: string, isNew: boolean = false) {
        this.id = id;
        this.displayName = displayName;
        this.description = description;
        this.isNew = isNew;

        if (propertyNames[0]) this.centerPropName = propertyNames[0];
        if (propertyNames[1]) this.corePropName = propertyNames[1];
        if (propertyNames[2]) this.projectPropName = propertyNames[2];

        if (pickListNames.some(item => item.includes("center"))) {
            this.centerPickListName = pickListNames.find(item => item.includes("center"));
        }
        if (pickListNames.some(item => item.includes("core"))) {
            this.corePickListName = pickListNames.find(item => item.includes("core"));
        }
        if (pickListNames.some(item => item.includes("project"))) {
            this.projectPickListName = pickListNames.find(item => item.includes("project"));
        }

    }

    generateHtml(): string {
        let size = "";
        if (this.isNew) {
            size = "col-lg-5";
        }

        let html = `
            <div id="${this.id}-center-container" class="mb-3 col-12 ${size} px-0">
                <label for="" class="required">Center</label>              
                <select id="${this.id}-center" class="selectpicker dropdown list-management-dropdown" title="None Selected" data-width="100%" data-container="body" data-dropup-auto="false" data-size="5"></select>
            </div>
            <div class="col-12 my-3 px-0" id="${this.id}-type-container">
                <div class="form-check form-check-inline">
                    <input class="form-check-input mb-0" type="radio" name="${this.id}-radio-type" id="${this.id}-radio-core" value="core" checked>
                    <label class="form-check-label mb-0" for="${this.id}-radio-core">Core</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input mb-0" type="radio" name="${this.id}-radio-type" id="${this.id}-radio-project" value="project">
                    <label class="form-check-label mb-0" for="${this.id}-radio-project">Project</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input mb-0" type="radio" name="${this.id}-radio-type" id="${this.id}-radio-none" value="none">
                    <label class="form-check-label mb-0" for="${this.id}-radio-none">N/A</label>
                </div>
            </div>
            <div id="${this.id}-core-container" class="mb-3 col-12 ${size} px-0">
                <label for="" class="required">Core</label>              
                <select id="${this.id}-core" class="selectpicker dropdown list-management-dropdown" title="None Selected" data-width="100%" data-container="body" data-dropup-auto="false" data-size="5"></select>
            </div>
            <div id="${this.id}-project-container" class="mb-3 col-12 ${size} px-0 d-none">
                <label for="" class="required">Project</label>              
                <select id="${this.id}-project" class="selectpicker dropdown list-management-dropdown" title="None Selected" data-width="100%" data-container="body" data-dropup-auto="false" data-size="5"></select>
            </div>
        `;
        return html;
    }

    initialize(pickLists: JsonItem[], entityArr: any[]): void {
        // Create Lists
        this.centerList = [];
        this.coreList = [];
        this.projectList = [];

        let foundCenterList = pickLists.find(list => list.Id == this.centerPickListName)?.Json;
        let foundCoreList = pickLists.find(list => list.Id == this.corePickListName)?.Json;
        let foundProjectList = pickLists.find(list => list.Id == this.projectPickListName)?.Json;

        if (!foundCenterList || !foundCoreList || !foundProjectList) return;

        this.centerList = foundCenterList;
        this.coreList = foundCoreList;
        this.projectList = foundProjectList;

        let centerDropdownItems: PickListItem[] = [];
        this.centerList.forEach(center => {
            let option: PickListItem = {
                Id: center.Id,
                Value: center.CenterAbbreviation
            }
            centerDropdownItems.push(option);
        })

        this.generateDropdown(`${this.id}-center`, centerDropdownItems);

        $(`#${this.id}-center`).off("changed.bs.select").on("changed.bs.select", () => {
            this.updateCoreProjectDropdowns();
        });

        $(`#${this.id}-type-container`).off("change").on("change", () => {
            this.updateDropdownVisibility();
        })

        this.updateCoreProjectDropdowns();
    }

    updateDropdownVisibility(): void {
        let coreSelect = $(`#${this.id}-radio-core`);
        let coreContainer = $(`#${this.id}-core-container`);
        let coreDropdown = $(`#${this.id}-core`);
        let projectSelect = $(`#${this.id}-radio-project`);
        let projectContainer = $(`#${this.id}-project-container`);
        let projectDropdown = $(`#${this.id}-project`);
        let noneSelect = $(`#${this.id}-radio-none`);      

        if (coreSelect.is(":checked")) {
            projectDropdown.selectpicker("val", "0");
            coreContainer.removeClass("d-none");
            projectContainer.addClass("d-none");
        }
        else if (projectSelect.is(":checked")) {
            coreDropdown.selectpicker("val", "0");
            coreContainer.addClass("d-none");
            projectContainer.removeClass("d-none");
        }
        else if (noneSelect.is(":checked")) {
            projectDropdown.selectpicker("val", "0");
            coreDropdown.selectpicker("val", "0");
            projectContainer.addClass("d-none");
            coreContainer.addClass("d-none");
        }
    }

    updateCoreProjectDropdowns(): void {
        let centerId = $(`#${this.id}-center`).val();

        let coreOptions: PickListItem[] = [];
        let projectOptions: PickListItem[] = [];
        let filteredCores = this.coreList.filter(core => core.CenterId.toString() == centerId);
        let filteredProjects = this.projectList.filter(project => project.CenterId.toString() == centerId);
        filteredCores.forEach(core => {
            let option: PickListItem = {
                Id: core.Id,
                Value: core.CoreName
            }
            coreOptions.push(option);
        });
        filteredProjects.forEach(project => {
            let option: PickListItem = {
                Id: project.Id,
                Value: project.ProjectName
            }
            projectOptions.push(option);
        });

        this.generateDropdown(`${this.id}-core`, coreOptions);
        this.generateDropdown(`${this.id}-project`, projectOptions);

    }

    getValue(): any {
        return 0; // Not Used
    }

    getCenterValue(): number {
        let centerId = <string>$(`#${this.id}-center`).val();
        let parsedNum = parseInt(centerId);
        if (!parsedNum) {
            return 0;
        }
        return parsedNum;
    }

    getCoreValue(): number {
        let coreId = <string>$(`#${this.id}-core`).val();
        let parsedNum = parseInt(coreId);
        if (!parsedNum) {
            return 0;
        }
        return parsedNum;
    }

    getProjectValue(): number {
        let projectId = <string>$(`#${this.id}-project`).val();
        let parsedNum = parseInt(projectId);
        if (!parsedNum) {
            return 0;
        }
        return parsedNum;
    }

    validate(): boolean {
        let isValid: boolean = true;
        let dropdownIds = [`${this.id}-center`, `${this.id}-core`, `${this.id}-project`]

        dropdownIds.forEach(dropdownId => {
            if ($(`#${dropdownId}`).siblings(".dropdown-toggle").is(":visible")) {
                let val = $(`#${dropdownId}`).val();
                if (val) {
                    this.displayValid(dropdownId, true);
                }
                else {
                    this.displayValid(dropdownId, false);
                    isValid = false;
                }
            }
            else {
                this.resetDisplayValid(dropdownId);
            }
        })
        return isValid;
    }

    displayValid(dropdownId: string, isValid: boolean): void {
        if (isValid) {
            $(`#${dropdownId}`).siblings(".dropdown-toggle").addClass("is-valid").removeClass("is-invalid");
        }
        else {
            $(`#${dropdownId}`).siblings(".dropdown-toggle").removeClass("is-valid").addClass("is-invalid");
        }
    }

    resetDisplayValid(dropdownId: string) {
        $(`#${dropdownId}`).siblings(".dropdown-toggle").removeClass("is-valid").removeClass("is-invalid");
    }


    updateStoredValues(entityArray: any[]): void {
        // Only handling one element at a time
        if (entityArray.length == 0) return;

        let targetEntity = entityArray[0];
        this.storedCenterId = _.get(targetEntity, this.centerPropName);
        this.storedCoreId = _.get(targetEntity, this.corePropName);
        this.storedProjectId = _.get(targetEntity, this.projectPropName);

        this.populateField();
        
    }

    populateField(): void {
        if (this.storedCenterId == 0 && this.storedCoreId == 0 && this.storedProjectId == 0) {
            // New Item, Don't do anything
            return;
        }

        let centerSelect = $(`#${this.id}-center`);
        let coreSelect = $(`#${this.id}-radio-core`);
        let coreDropdown = $(`#${this.id}-core`);
        let projectSelect = $(`#${this.id}-radio-project`);
        let projectDropdown = $(`#${this.id}-project`);
        let noneSelect = $(`#${this.id}-radio-none`);  

        if (this.storedCenterId != 0) {
            centerSelect.selectpicker("val", this.storedCenterId.toString());
        }

        if (this.storedCoreId == 0 && this.storedProjectId == 0) {
            noneSelect.prop("checked", true).trigger("click").trigger("change");
        }
        else if (this.storedCoreId != 0) {
            coreSelect.prop("checked", true).trigger("click").trigger("change");
            coreDropdown.selectpicker("val", this.storedCoreId.toString());
        }
        else if (this.storedProjectId != 0) {
            projectSelect.prop("checked", true).trigger("click").trigger("change");
            projectDropdown.selectpicker("val", this.storedProjectId.toString());
        }
        
    }

    checkChanged(): boolean {
        if (this.getCenterValue() != this.storedCenterId || this.getCoreValue() != this.storedCoreId || this.getProjectValue() != this.storedProjectId) {
            return true;
        }
        else {
            return false;
        }
    }

    generateDropdown(dropdownId: string, dropdownItems: PickListItem[]): void {
        // Remove any previous options
        $(`#${dropdownId}`).find("option").remove();

        $(`#${dropdownId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });

        dropdownItems.sort((x1, x2) => x1.Value.localeCompare(x2.Value));
        dropdownItems.forEach((item: PickListItem) => {
            $(`#${dropdownId}`).append(new Option(item.Value, item.Id.toString(), false, false));
        });

        $(`#${dropdownId}`).selectpicker("refresh");
    }

    getPreviousDisplayValue(index): string {
        if (this.storedCenterId == 0) {
            return "None"
        }
        else if (this.storedCenterId != 0 && this.storedCoreId != 0) {
            let foundCenter = this.centerList.find(center => center.Id == this.storedCenterId);
            let foundCore = this.coreList.find(core => core.Id == this.storedCoreId);
            if (foundCenter && foundCore) {
                return `
                    ${foundCenter.CenterAbbreviation}<br/>
                    ${foundCore.CoreName}
                `
            }
        }
        else if (this.storedCenterId != 0 && this.storedProjectId != 0) {
            let foundCenter = this.centerList.find(center => center.Id == this.storedCenterId);
            let foundProject = this.projectList.find(project => project.Id == this.storedProjectId);
            if (foundCenter && foundProject) {
                return `
                    ${foundCenter.CenterAbbreviation}<br/>
                    ${foundProject.ProjectName}
                `
            }
        }
        else {
            let foundCenter = this.centerList.find(center => center.Id == this.storedCenterId);
            if (foundCenter) {
                return foundCenter.CenterAbbreviation;
            }
        }

        return "None";     
    }

    getCurrentDisplayValue(): string {
        let currentCenterId = $(`#${this.id}-center`).val();
        let currentCoreId = $(`#${this.id}-core`).val();
        let currentProjectId = $(`#${this.id}-project`).val();

        if (!currentCenterId) {
            return "None"
        }
        else if (currentCenterId && currentCoreId) {
            let foundCenter = this.centerList.find(center => center.Id.toString() == currentCenterId);
            let foundCore = this.coreList.find(core => core.Id.toString() == currentCoreId);
            if (foundCenter && foundCore) {
                return `
                    ${foundCenter.CenterAbbreviation}<br/>
                    ${foundCore.CoreName}
                `
            }
        }
        else if (currentCenterId && currentProjectId) {
            let foundCenter = this.centerList.find(center => center.Id.toString() == currentCenterId);
            let foundProject = this.projectList.find(project => project.Id.toString() == currentProjectId);
            if (foundCenter && foundProject) {
                return `
                    ${foundCenter.CenterAbbreviation}<br/>
                    ${foundProject.ProjectName}
                `
            }
        }
        else {
            let foundCenter = this.centerList.find(center => center.Id.toString() == currentCenterId);
            if (foundCenter) {
                return foundCenter.CenterAbbreviation;
            }
        }

        return "None"; 
    }
}
